import { Typography as TypographyType } from '@/schemas/sceneDataSchema';
import { Typography } from '@mui/material';

export const TypographyBlock = ({ component }: { component: TypographyType }) => {
  return (
    <Typography
      color={component.color}
      align={component.align}
      variant={component.variant}
      fontWeight={component.font_weight ?? undefined}
    >
      {component.text}
    </Typography>
  );
};

export const TypographyInline = ({ component }: { component: TypographyType }) => {
  return (
    <Typography
      component={'span'}
      color={component.color}
      align={component.align}
      variant={component.variant}
      fontWeight={component.font_weight ?? undefined}
    >
      {component.text}
    </Typography>
  );
};
